import { createPortal } from 'react-dom';
import { AppNotification } from '../AppNotification';

const rootDiv = document.getElementById('root') as HTMLDivElement;

export const NotificationPortal = () =>
  createPortal(<AppNotification />, rootDiv);
